<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>MISA Rewind</h1>
        <h4>MISA Rewind is a celebration to wrap up MISA’s 26th year as an organization. The organization will be livestreaming a program that consists of this year’s MISAwards where officers of the org will be awarded for their hard work and achievements and performances to showcase the talent of fellow MISAns. Along with this, the incoming MISA Executive Board will be welcomed, and a culminating activity will happen for all current MISAns and alumni to bond over as the closing event of the school year.</h4>

        <!-- POSITIONS -->
        <h3>Positions:</h3>

        <!-- POSITION -->
        <h2><b>Operations Manager</b></h2>
        <ul>
            <li>Gathers all documents pertinent to their assigned event project</li>
            <li>Takes minutes of the meeting and checks project team attendance</li>
            <li>Reminds team members of their deliverables and deadlines</li>
            <li>Handles BETA presentation material, event registration, and project evaluations</li>
            <li>Works closely with the Events Associate for Organizational Development or any assigned supervisor under the OSG</li>
        </ul>

        <!-- POSITION -->
        <h2><b>Promotional Strategist</b></h2>
        <ul>
            <li>Conceptualizes promotional strategy and timeline</li>
            <li>Handles the scheduling of the blasts and execution of promotional materials</li>
            <li>Oversees non-traditional promotions (and video/photo shoots once onsite classes are back)</li>
            <li>Communicates with Creative Directors for needed promotional materials</li>
            <li>Assists the AVP in compiling individual promotional timelines into the promotional calendar</li>
            <li>Sending Blast Requests through the Communications Cluster Blast Request Form</li>
            <li>Administers brainstorming sessions of the events they are deployed to with the supervision of the AVP for Promotional Strategy</li>
            <li>Utilizes selected social media channels of the organization</li>
        </ul>

        <!-- POSITION -->
        <h2><b>Video Editor</b></h2>
        <ul>
            <li>Edits videos of recordings made for events</li>
            <li>Updates the AVP for Creatives and Publications regarding changes made, and later submits video for approval</li>
            <li>Can be deployed to events or activities that require video promotions, or event videos</li>
            <li>Generates quality videos that will be blasted through the organization’s channels (e, g, Vimeo, Facebook, etc.)</li>
            <li>Required to upload all raw and post-processed videos and materials to the official Communications drive assigned to their event for archival and documentation purposes</li>
            <li>NOTE: While online classes are going on, officers who apply to be videographers will be’ responsible in collating all previously taken videos (both post-processed and raw footage)  for previous events and archive them properly for future uses for promotions</li>
        </ul>

        <h3><b>Programs Head</b></h3>
        <ul>
            <li>Works closely with the VP for Events and the assigned AVP for Events Management for the event</li>
            <li>The Programs Head handles the program flow for the event. This includes  ensuring the timely start and finish of the event</li>
            <li>Communicates with marketing and logistics in regard to general event necessities </li>
            <li>Creation of the script and operation schedule for the event days</li>
            <li>In-charge of finding hosts, speakers, and other needed people for the program</li>
            <li>Conceptualizes online games for the participants’ interactions</li>
            <li>Facilitates a dry run to prevent any issues in the event flow</li>
        </ul>

        <h3><b>Logistics Head</b></h3>
        <ul>
            <li>Works closely with the VP for Events and the assigned AVP for Events Management for the event</li>
            <li>In-charge of finding an appropriate platform for the event</li>
            <li>Tests the software and needed files for the program beforehand</li>
            <li>Assist Programs in conducting a test run 1 week prior to the event</li>
            <li>Executes the program on the day itself along with the program heads</li>
        </ul>

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerComms'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


